import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 訪客模式頂部橫幅組件 - 顯示訪客狀態和登入提示
 * 精簡且 stateless，純顯示組件
 */
export default function GuestBanner() {
  const navigate = useNavigate();

  return (
    <div style={{
      position: 'relative',
      zIndex: 100,
      backgroundColor: '#667eea',
      color: 'white',
      padding: '12px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      fontSize: '14px',
      flexShrink: 0
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
        <strong>訪客模式</strong>
        <span style={{ opacity: 0.9 }}>- 您正在以唯讀方式瀏覽此活動</span>
      </div>
      <button 
        onClick={() => navigate('/')}
        style={{
          backgroundColor: 'white',
          color: '#667eea',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '13px',
          transition: 'all 0.2s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#f8f9ff';
          e.target.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'white';
          e.target.style.transform = 'translateY(0)';
        }}
      >
        創建自己的空間
      </button>
    </div>
  );
}
